module.exports = __webpack_public_path__ + "img/027-schedule.9aaa8a1e.svg";